(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .directive('webinarCard', webinarCard);

  /* ngInject */
  function webinarCard($sce) {
    return {
      restrict: 'E',
      templateUrl: '/templates/compliance_services/components/webinar-card.directive.html',
      scope: {
        webinar: '='
      },
      link: (scope, element, _attrs) => {
        scope.trustWebinarUrl = (webinarUrl) => {
          return $sce.trustAsResourceUrl(webinarUrl);
        };

        scope.isWebexWebinar = (webinarUrl) => {
          return webinarUrl.includes('trinovus.webex.com');
        };
      }
    }; 
  }
})();
